module.exports = "<!-- <span style='display:block;font-size:30px;padding:20px 0px;'>Correspondence Tracking</span> -->\n<app-ct-menu></app-ct-menu>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/correspondence-tracking/correspondance-tracking.component.html
// module id = ./src/app/correspondence-tracking/correspondance-tracking.component.html
// module chunks = main